import { useEffect, useState } from 'react';
import TimeStr from 'utils/shared/TimeStr';

function ContentDateTime({ date }: { date?: Date }) {
  const [dateStr, setDateStr] = useState<string>('');

  useEffect(() => {
    // Function to update the date string
    const updateDateStr = () => {
      if (date) {
        setDateStr(TimeStr.getContentDateTime(date));
      }
    };

    // Initially update the date string upon component mount or date change
    updateDateStr();

    // Clear any existing timeout
    const timeoutId = setTimeout(() => {
      updateDateStr();
    }, 60 * 1000); // Set delay to 1 minute

    // Cleanup function to clear timeout on unmount or when date changes
    return () => clearTimeout(timeoutId);
  }, [date]);

  // Early return if no date is provided
  if (!date) {
    return null;
  }

  return <>{dateStr}</>;
}

export default ContentDateTime;
